export default __webpack_public_path__ + "static/media/48-icon-close.95dc9366.svg";